var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4115 6.65619C19.0696 4.25659 17.5871 2.17091 15.4333 1.05948C13.2793 -0.0520541 10.7205 -0.0520541 8.56671 1.05948C6.41269 2.17102 4.93021 4.25664 4.58831 6.65619C2.86892 6.73834 1.324 7.73152 0.535388 9.26159C-0.253278 10.7919 -0.165637 12.6264 0.765316 14.0744C1.69626 15.5224 3.32882 16.3639 5.04821 16.2816H8.7916V10.9342C8.7916 9.78798 9.40303 8.72875 10.3958 8.15558C11.3885 7.58225 12.6117 7.58225 13.6044 8.15558C14.5971 8.72869 15.2086 9.78793 15.2086 10.9342V16.2818H18.9518V16.2816C20.6714 16.364 22.304 15.5224 23.2349 14.0744C24.1656 12.6264 24.2532 10.7919 23.4648 9.2616C22.6761 7.73153 21.1312 6.73831 19.4116 6.65619L19.4115 6.65619Z",
    fill: "url(#paint0_linear_1_121)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9678 18.7306C15.7668 18.5282 15.4935 18.4143 15.2083 18.4143C14.9231 18.4143 14.6498 18.5282 14.4489 18.7306L13.0693 20.1209V10.934C13.0693 10.5519 12.8654 10.1987 12.5345 10.0077C12.2036 9.81676 11.796 9.81676 11.4651 10.0077C11.1342 10.1987 10.9303 10.5518 10.9303 10.934V20.1209L9.55078 18.7306L9.55056 18.7304C9.27935 18.4592 8.88385 18.3533 8.51333 18.4526C8.14283 18.5519 7.85318 18.8413 7.75388 19.2118C7.65459 19.5826 7.76066 19.9778 8.03187 20.2493L11.2405 23.4579V23.4577C11.4412 23.6603 11.7145 23.774 11.9997 23.774C12.2849 23.774 12.5582 23.6603 12.7592 23.4577L15.9677 20.2491V20.2493C16.1702 20.0484 16.2841 19.775 16.2841 19.4898C16.2841 19.2046 16.1701 18.9313 15.9677 18.7304L15.9678 18.7306Z",
    fill: "url(#paint1_linear_1_121)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_121",
    x1: -1.84127,
    y1: 16.2871,
    x2: 17.8186,
    y2: -5.11443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E5CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DD6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_121",
    x1: 7.06005,
    y1: 23.774,
    x2: 19.824,
    y2: 18.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E5CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DD6FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.68e5dc880a3cc700045f05870087e3db.svg";
export { ForwardRef as ReactComponent };